import { cn } from '../../lib/cn';
import type { VoiceCommandRow } from '../../mobilecompanion/framework';

type Props = { commands?: VoiceCommandRow[] };

export function VoiceExperiencePanel({ commands = [] }: Props) {
  return (
    <div className="space-y-2">
      {commands.map((c) => (
        <div key={c.command} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-brand-600">{c.feature}</p>
            <p className="mt-0.5 text-sm">&quot;{c.command}&quot;</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            c.status === 'ready' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
            'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
          )}>
            {c.status.replace('_', ' ')}
          </span>
        </div>
      ))}
    </div>
  );
}
